export default __webpack_public_path__ + "static/clickmeeting-30ce70027edf924bd2a53b3675f61fb2.png";